export const qrcodeForChannel_2023jituandangjiangongyi = 'https://res.miaocode.com/slim/tapd_48087013_base64_1689834383_311-1689839735490.png'



// WEBPACK FOOTER //
// ./src/utils/const.js